module.exports = __webpack_public_path__ + "img/solar2d.9d83dea1.svg";